import {LocaleTag} from "../../../../../api/generated";
import {SelectOption} from "../../../../elements/select/SelectDropdown";
import {getLocaleTagTitle} from "../../../../../utils/enumValueTitleUtil";

export const widgetLocaleOptions: SelectOption<LocaleTag>[] = [
    {label: getLocaleTagTitle(LocaleTag.EnGb), value: LocaleTag.EnGb},
    {label: getLocaleTagTitle(LocaleTag.EnUs), value: LocaleTag.EnUs},
    {label: getLocaleTagTitle(LocaleTag.EnCa), value: LocaleTag.EnCa},
    {label: getLocaleTagTitle(LocaleTag.FrFr), value: LocaleTag.FrFr},
    {label: getLocaleTagTitle(LocaleTag.FrCa), value: LocaleTag.FrCa},
    {label: getLocaleTagTitle(LocaleTag.DeDe), value: LocaleTag.DeDe},
    {label: getLocaleTagTitle(LocaleTag.EsEs), value: LocaleTag.EsEs},
    {label: getLocaleTagTitle(LocaleTag.JaJp), value: LocaleTag.JaJp},
    {label: getLocaleTagTitle(LocaleTag.ArAe), value: LocaleTag.ArAe}
];

export const getWidgetLocaleLabel = (locale: LocaleTag): string => {
    const option = widgetLocaleOptions.find(item => item.value === locale);
    return option?.label ?? locale;
};
